import { render, staticRenderFns } from "./BriefcaseFolderMoveDialog.vue?vue&type=template&id=6a15f5dc"
import script from "./BriefcaseFolderMoveDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BriefcaseFolderMoveDialog.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports